import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'connect-website';
  languageKey = "lang";

  constructor(public translate: TranslateService, private router: Router) {
    translate.addLangs(['en', 'pt', 'es']);
    const storedLanguage = localStorage.getItem(this.languageKey);

    if (storedLanguage) {
      translate.use(storedLanguage.match(/en|pt|es/) ? storedLanguage : 'en');
    }
    else {
      const language = translate.getBrowserLang();
      localStorage.setItem(this.languageKey, language);
      translate.setDefaultLang(language);
    }

    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'UA-1283795-54', { 'page_path': e.urlAfterRedirects });
    });
  }
}
